module.exports = __webpack_public_path__ + "static/media/piston_case.d4368913.png";